import { render } from "./ExchangeDetail.vue?vue&type=template&id=51155459&scoped=true"
import script from "./ExchangeDetail.vue?vue&type=script&lang=ts"
export * from "./ExchangeDetail.vue?vue&type=script&lang=ts"

import "./ExchangeDetail.vue?vue&type=style&index=0&id=51155459&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51155459"

export default script